module.exports = __webpack_public_path__ + "img/logo-white-small.1c57bd3e.png";